import { useEffect, useState } from 'react'

import { useHasConsent } from './useHasConsent/useHasConsent'

export const useRenderExitPopup = (exitPopup: boolean) => {
  const [renderPopup, setRenderPopup] = useState(false)
  const hasConsent = useHasConsent(['necessary'], 'any')

  useEffect(() => {
    if (exitPopup && hasConsent) {
      setRenderPopup(true)
    }
  }, [exitPopup, hasConsent])

  return renderPopup
}
